export const environment = {
  production: false,
  api: 'https://devservices.sequation.net',
  enableCtrl: true,
  azureBlobStorage: 'https://sequationdevsa.blob.core.windows.net'
};
